<template>
	<div class="container">
		<div class="content">
			<div class="breadcrumb">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item replace :to="{ path: '/my/index' }">个人中心</el-breadcrumb-item>
					<el-breadcrumb-item replace :to="{ path: '/my/insureList' }">我的保单</el-breadcrumb-item>
					<el-breadcrumb-item>保单详情</el-breadcrumb-item>
				</el-breadcrumb>
			</div>

			<div class="box">
				<div class="box-title">
					基本信息
				</div>

				<div class="basic-info">
					<div class="basic-item">
						<div class="basic-item-title">
							产品名称
						</div>
						<div class="basic-item-value">
							{{ data.goods_name }} - {{ data.goods_specs_name }}
						</div>
					</div>
					<div class="basic-item">
						<div class="basic-item-title">
							保单号
						</div>
						<div class="basic-item-value">
							{{ data.policy_no || '暂未生成' }}
						</div>
					</div>
					<div class="basic-item">
						<div class="basic-item-title">
							承保公司
						</div>
						<div class="basic-item-value">
							由{{ data.insurer_name }}承保
						</div>
					</div>
					<div class="basic-item">
						<div class="basic-item-title">
							保单状态
						</div>
						<div class="basic-item-value">
							{{ data.statusText }}
						</div>
					</div>
					<div class="basic-item">
						<div class="basic-item-title">
							起保时间
						</div>
						<div class="basic-item-value">
							{{ data.pln_start_date }}
						</div>
					</div>
					<div class="basic-item">
						<div class="basic-item-title">
							终保时间
						</div>
						<div class="basic-item-value">
							{{ data.pln_end_date }}
						</div>
					</div>
					<div class="basic-item">
						<div class="basic-item-title">
							保险周期
						</div>
						<div class="basic-item-value">
							{{ data.insured_days }}天
						</div>
					</div>
					<div class="basic-item">
						<div class="basic-item-title">
							保费
						</div>
						<div class="basic-item-value">
							￥{{ data.amount }}
						</div>
					</div>
					<div class="basic-item">
						<div class="basic-item-title">
							下单时间
						</div>
						<div class="basic-item-value">
							{{ data.created_at }}
						</div>
					</div>
				</div>

				<div class="box-title">
					备注信息
				</div>

				<div class="remark">
					{{ data.remark }}
				</div>
			</div>

			<div class="box">
				<div class="box-title">
					保单服务
				</div>
				<div class="box-btn">
					<div class="box-btn-item" @click="$navto('/my/createClaim?orderId=' + data.id)">
						<el-image :src="require('@/../static/my/insure/sqlp.png')" />
						<div>申请理赔</div>
					</div>
					<div class="box-btn-item" @click="handleInvoiceClick">
						<el-image :src="require('@/../static/my/insure/kjfp.png')" />
						<div>开具发票</div>
					</div>
					<div class="box-btn-item">
						<el-image :src="require('@/../static/my/insure/dzbd.png')" />
						<div>电子保单</div>
					</div>
				</div>
			</div>

			<div class="box">
				<div class="box-title">
					投保人信息
				</div>

				<div class="basic-info" v-if="data.applicant_info">
					<div class="basic-item">
						<div class="basic-item-title">
							类型
						</div>
						<div class="basic-item-value">
							{{ data.applicant_info.applicant_type_text }}
						</div>
					</div>
					<div class="basic-item">
						<div class="basic-item-title">
							名称
						</div>
						<div class="basic-item-value">
							{{ data.applicant_info.applicant_name }}
						</div>
					</div>
					<div class="basic-item">
						<div class="basic-item-title">
							证件类型
						</div>
						<div class="basic-item-value">
							{{ data.applicant_info.applicant_id_type_text }}
						</div>
					</div>
					<div class="basic-item">
						<div class="basic-item-title">
							证件号码
						</div>
						<div class="basic-item-value">
							{{ data.applicant_info.applicant_id_number }}
						</div>
					</div>
					<div class="basic-item" v-if="data.applicant_info.applicant_type == 1">
						<div class="basic-item-title">
							联系人
						</div>
						<div class="basic-item-value">
							{{ data.applicant_info.applicant_contact_name }}
						</div>
					</div>
					<div class="basic-item">
						<div class="basic-item-title">
							联系电话
						</div>
						<div class="basic-item-value">
							{{ data.applicant_info.applicant_phone }}
						</div>
					</div>
				</div>
			</div>

			<div class="box">
				<div class="box-title">
					被保人信息
				</div>

				<div class="table">
					<div class="table-item table-header">
						<div class="table-title">
							姓名
						</div>
						<div class="table-title">
							证件类型
						</div>
						<div class="table-title">
							证件号码
						</div>
						<div class="table-title">
							手机号码
						</div>
					</div>
					<div class="table-item" v-for="(item, index) in displayedInsured" :key="index">
						<div class="table-title">
							{{ item.isrd_name }}
						</div>
						<div class="table-title">
							{{ item.isrd_cret_type_text }}
						</div>
						<div class="table-title">
							{{ item.isrd_cret_code }}
						</div>
						<div class="table-title">
							{{ item.isrd_telnumber }}
						</div>
					</div>
				</div>

				<div class="more" @click="insuredMore = !insuredMore" v-if="data.insured && data.insured.length > 10">
					{{ insuredMore ? '收起' : '查看更多' }}
				</div>
			</div>

			<div class="box">
				<div class="box-title">
					保障项目
				</div>

				<div class="item" v-for="(item, index) in data.coverage_plan" :key="index">
					<div class="item-title">
						{{ item.name }}
					</div>
					<div class="item-value">
						{{ item.amount }}
					</div>
				</div>

				<!-- <div class="more">查看更多</div> -->
			</div>
		</div>

		<el-dialog title="申请开票" :visible.sync="invoiceVisible" width="40%">
			<el-form :model="invoiceForm" :rules="invoiceRules" ref="invoiceForm" label-width="120px" class="form">
				<el-form-item label="发票类型" prop="type">
					<el-radio-group v-model="invoiceForm.type" :disabled="invoiceForm.tax_player_type === 2">
						<el-radio :label="1">电子普票</el-radio>
						<el-radio :label="2" :disabled="invoiceForm.tax_player_type === 2">纸质专票</el-radio>
					</el-radio-group>
					<div class="form-tip" v-if="invoiceForm.tax_player_type === 2">
						*个人只能开具电子普票
					</div>
				</el-form-item>
				<el-form-item label="纳税人类型" prop="tax_player_type">
					<el-radio-group v-model="invoiceForm.tax_player_type">
						<el-radio :label="1">企业</el-radio>
						<el-radio :label="2">个人</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="发票抬头" prop="customer_name">
					<el-input v-model="invoiceForm.customer_name" placeholder="请输入发票抬头" maxlength="255"></el-input>
				</el-form-item>
				
				<!-- 企业纳税人需要填写更多信息 -->
				<template v-if="invoiceForm.tax_player_type === 1">
					<el-form-item label="纳税人识别号" prop="tax_player_reg_num">
						<el-input v-model="invoiceForm.tax_player_reg_num" placeholder="请输入纳税人识别号" maxlength="255"></el-input>
					</el-form-item>
					
					<!-- 企业专票需要填写完整税务信息 -->
					<template v-if="invoiceForm.type === 2">
						<el-form-item label="纳税人地址" prop="tax_player_address">
							<el-input v-model="invoiceForm.tax_player_address" placeholder="请输入纳税人地址" maxlength="255"></el-input>
						</el-form-item>
						<el-form-item label="纳税人电话" prop="tax_player_tel_num">
							<el-input v-model="invoiceForm.tax_player_tel_num" placeholder="请输入纳税人电话" maxlength="255"></el-input>
						</el-form-item>
						<el-form-item label="开户银行" prop="tax_player_bank">
							<el-input v-model="invoiceForm.tax_player_bank" placeholder="请输入开户银行" maxlength="255"></el-input>
						</el-form-item>
						<el-form-item label="银行账号" prop="tax_player_bank_account_num">
							<el-input v-model="invoiceForm.tax_player_bank_account_num" placeholder="请输入银行账号" maxlength="255"></el-input>
						</el-form-item>
					</template>
				</template>

				<el-form-item label="接收邮箱" prop="email_address">
					<el-input v-model="invoiceForm.email_address" placeholder="请输入接收邮箱" maxlength="255"></el-input>
				</el-form-item>
				
				<!-- 纸质专票需要填写邮寄信息 -->
				<template v-if="invoiceForm.type === 2">
					<el-form-item label="收件人" prop="addressee">
						<el-input v-model="invoiceForm.addressee" placeholder="请输入收件人姓名" maxlength="255"></el-input>
					</el-form-item>
					<el-form-item label="手机号码" prop="mobile_phone_no">
						<el-input v-model="invoiceForm.mobile_phone_no" placeholder="请输入收件人手机号码" maxlength="255"></el-input>
					</el-form-item>
					<el-form-item label="收件地址" prop="address">
						<el-input v-model="invoiceForm.address" placeholder="请输入收件地址" maxlength="255"></el-input>
					</el-form-item>
				</template>

				<el-form-item label="备注" prop="tax_bz">
					<el-input type="textarea" v-model="invoiceForm.tax_bz" placeholder="请输入备注信息" maxlength="255" :rows="3"></el-input>
				</el-form-item>

				<el-form-item>
					<el-button class="invoice-btn save" @click="submitInvoice" :loading="invoiceLoading">
						确认开票
					</el-button>
					<el-button class="invoice-btn" @click="cancelInvoice">
						取消
					</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<mainFooter />
	</div>
</template>

<script>
	import mainFooter from '../../../../src/basic/components/layout/mainFooter.vue';
	export default {
		components: {
			mainFooter,
		},
		data() {
			return {
				data: {},
				insuredMore: false,
				invoiceVisible: false,
				invoiceLoading: false,
				invoiceForm: {
					type: 1, // 1-电子普票,2-纸质专票
					tax_player_type: 2, // 1-企业,2-个人
					customer_name: '',
					tax_player_reg_num: '',
					tax_player_address: '',
					tax_player_tel_num: '',
					tax_player_bank: '',
					tax_player_bank_account_num: '',
					email_address: '',
					mobile_phone_no: '',
					addressee: '',
					address: '',
					tax_bz: ''
				},
				invoiceRules: {
					type: [
						{ required: true, message: '请选择发票类型', trigger: 'change' }
					],
					tax_player_type: [
						{ required: true, message: '请选择纳税人类型', trigger: 'change' }
					],
					customer_name: [
						{ required: true, message: '请输入发票抬头', trigger: 'blur' }
					],
					email_address: [
						{ required: true, message: '请输入接收邮箱', trigger: 'blur' },
						{ type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
					],
					tax_player_reg_num: [
						{ 
							required: true, 
							message: '请输入纳税人识别号', 
							trigger: 'blur',
							validator: (rule, value, callback) => {
								if (this.invoiceForm.tax_player_type === 1 && !value) {
									callback(new Error('请输入纳税人识别号'));
								} else {
									callback();
								}
							}
						}
					],
					tax_player_address: [
						{ 
							required: true, 
							message: '请输入纳税人地址', 
							trigger: 'blur',
							validator: (rule, value, callback) => {
								if (this.invoiceForm.tax_player_type === 1 && this.invoiceForm.type === 2 && !value) {
									callback(new Error('请输入纳税人地址'));
								} else {
									callback();
								}
							}
						}
					],
					tax_player_tel_num: [
						{ 
							required: true, 
							message: '请输入纳税人电话', 
							trigger: 'blur',
							validator: (rule, value, callback) => {
								if (this.invoiceForm.tax_player_type === 1 && this.invoiceForm.type === 2 && !value) {
									callback(new Error('请输入纳税人电话'));
								} else {
									callback();
								}
							}
						}
					],
					tax_player_bank: [
						{ 
							required: true, 
							message: '请输入开户银行', 
							trigger: 'blur',
							validator: (rule, value, callback) => {
								if (this.invoiceForm.tax_player_type === 1 && this.invoiceForm.type === 2 && !value) {
									callback(new Error('请输入开户银行'));
								} else {
									callback();
								}
							}
						}
					],
					tax_player_bank_account_num: [
						{ 
							required: true, 
							message: '请输入银行账号', 
							trigger: 'blur',
							validator: (rule, value, callback) => {
								if (this.invoiceForm.tax_player_type === 1 && this.invoiceForm.type === 2 && !value) {
									callback(new Error('请输入银行账号'));
								} else {
									callback();
								}
							}
						}
					],
					addressee: [
						{ 
							required: true, 
							message: '请输入收件人', 
							trigger: 'blur',
							validator: (rule, value, callback) => {
								if (this.invoiceForm.type === 2 && !value) {
									callback(new Error('请输入收件人'));
								} else {
									callback();
								}
							}
						}
					],
					mobile_phone_no: [
						{ 
							required: true, 
							message: '请输入手机号码', 
							trigger: 'blur',
							validator: (rule, value, callback) => {
								if (this.invoiceForm.type === 2 && !value) {
									callback(new Error('请输入手机号码'));
								} else {
									callback();
								}
							}
						}
					],
					address: [
						{ 
							required: true, 
							message: '请输入收件地址', 
							trigger: 'blur',
							validator: (rule, value, callback) => {
								if (this.invoiceForm.type === 2 && !value) {
									callback(new Error('请输入收件地址'));
								} else {
									callback();
								}
							}
						}
					]
				}
			}
		},
		computed: {
			// 添加计算属性来控制显示的被保人数据
			displayedInsured() {
				if (!this.data.insured) return [];
				if (this.insuredMore) {
					return this.data.insured; // 显示全部
				} else {
					return this.data.insured.slice(0, 10); // 只显示前10条
				}
			},
			// 判断是否可以开票
			canInvoice() {
				if (!this.data.status && this.data.status !== 0) return true;
				// 不能开票的条件：status == 0 || status == 4 || invoice_status > 0
				const cannotInvoice = 
					this.data.status === 0 || 
					this.data.status === 4 || 
					(this.data.invoice_status && this.data.invoice_status > 0);
				return !cannotInvoice;
			}
		},
		watch: {
			invoiceVisible(val) {
				if (!val) {
					this.resetInvoiceForm();
				}
			},
			'invoiceForm.tax_player_type'(val) {
				// 切换纳税人类型时重置相关字段
				if (val === 2) {
					// 个人只能选择电子普票
					this.invoiceForm.type = 1;
					this.invoiceForm.tax_player_reg_num = '';
					this.invoiceForm.tax_player_address = '';
					this.invoiceForm.tax_player_tel_num = '';
					this.invoiceForm.tax_player_bank = '';
					this.invoiceForm.tax_player_bank_account_num = '';
				}
			},
			'invoiceForm.type'(val) {
				// 切换发票类型时重置邮寄相关字段
				if (val === 1) {
					this.invoiceForm.addressee = '';
					this.invoiceForm.mobile_phone_no = '';
					this.invoiceForm.address = '';
				}
			}
		},
		mounted() {
			this.getData(this.$route.query.id);
		},
		methods: {
			getData(id) {
				if (!id) return;
				this.$load();
				this.$get('app-order/' + id).then(res => {
					this.data = res.data;
				}).catch(err => {
					this.$message.error(err);
				})
			},
			
			// 点击开具发票按钮
			handleInvoiceClick() {
				if (!this.canInvoice) {
					let message = '';
					if (this.data.status === 0) {
						message = '订单状态为待支付，无法开具发票';
					} else if (this.data.status === 4) {
						message = '订单已取消，无法开具发票';
					} else if (this.data.invoice_status && this.data.invoice_status > 0) {
						message = '发票已开具，无法重复申请';
					} else {
						message = '当前订单状态无法开具发票';
					}
					this.$message.warning(message);
					return;
				}
				
				// 检查保单号是否存在
				if (!this.data.policy_no) {
					this.$message.warning('保单号暂未生成，无法开具发票');
					return;
				}
				
				this.invoiceVisible = true;
			},
			
			// 提交开票申请
			submitInvoice() {
				this.$refs.invoiceForm.validate((valid) => {
					if (valid) {
						// 再次验证个人不能开专票
						if (this.invoiceForm.tax_player_type === 2 && this.invoiceForm.type === 2) {
							this.$message.error('个人只能开具电子普票');
							return false;
						}
						
						// 再次验证订单状态
						if (!this.canInvoice) {
							this.$message.warning('订单状态已变更，无法开具发票');
							return false;
						}
						
						this.invoiceLoading = true;
						
						// 构造提交数据
						const submitData = {
							...this.invoiceForm,
							order_id: this.data.id,
						};
						
						this.$post('app-order-invoice', submitData).then(res => {
							this.$message.success('开票申请提交成功');
							this.invoiceVisible = false;
							this.resetInvoiceForm();
							// 重新加载订单数据更新发票状态
							this.getData(this.data.id);
						}).catch(err => {
							this.$message.error(err.message || '开票申请提交失败');
						}).finally(() => {
							this.invoiceLoading = false;
						});
					} else {
						this.$message.warning('请完善表单信息');
						return false;
					}
				});
			},
			
			// 取消开票
			cancelInvoice() {
				this.invoiceVisible = false;
				this.resetInvoiceForm();
			},
			
			// 重置开票表单
			resetInvoiceForm() {
				this.$refs.invoiceForm && this.$refs.invoiceForm.resetFields();
				this.invoiceForm = {
					type: 1,
					tax_player_type: 2,
					customer_name: '',
					tax_player_reg_num: '',
					tax_player_address: '',
					tax_player_tel_num: '',
					tax_player_bank: '',
					tax_player_bank_account_num: '',
					email_address: '',
					mobile_phone_no: '',
					addressee: '',
					address: '',
					tax_bz: ''
				};
				this.invoiceLoading = false;
			}
		},
	}
</script>

<style lang="scss" scoped>
	.container {
		width: 100%;
		background-color: #F7F7F7;

		/* 笔记本屏幕适配 */
		@media (min-width: 1024px) and (max-width: 1440px) {
			padding-bottom: 20px;
		}

		.content {
			min-height: calc(100vh - 300px);
			margin: 20px auto 40px;
			width: 68%;

			/* 笔记本屏幕适配 */
			@media (min-width: 1024px) and (max-width: 1440px) {
				width: 85%;
				margin: 15px auto 30px;
				min-height: calc(100vh - 250px);
			}

			.box {
				margin-top: 20px;
				padding: 20px;
				border-radius: 10px;
				background-color: #fff;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					margin-top: 18px;
					padding: 18px;
					border-radius: 8px;
				}

				.box-title {
					color: #333333;
					font-size: 20px;
					font-weight: bold;
					width: 120px;
					margin-bottom: 20px;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						font-size: 18px;
						margin-bottom: 18px;
						width: 110px;
					}
				}

				.basic-info {
					width: 100%;
					display: flex;
					flex-wrap: wrap;
					padding-bottom: 20px;
					margin-top: -15px;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						padding-bottom: 18px;
						margin-top: -12px;
					}

					.basic-item {
						display: flex;
						width: 33.3%;
						margin-top: 15px;
						font-size: 14px;

						/* 笔记本屏幕适配 */
						@media (min-width: 1024px) and (max-width: 1440px) {
							width: 50%; /* 改为2列布局 */
							margin-top: 12px;
							font-size: 13px;
						}

						.basic-item-title {
							width: 80px;
							color: #666666;

							/* 笔记本屏幕适配 */
							@media (min-width: 1024px) and (max-width: 1440px) {
								width: 70px;
							}
						}

						.basic-item-value {
							color: #333333;
							flex: 1;
						}
					}
				}

				.remark {
					font-size: 14px;
					color: #333333;
					border-top: 1px solid #EEEEEE;
					padding-top: 20px;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						font-size: 13px;
						padding-top: 18px;
					}
				}

				.box-btn {
					display: flex;
					justify-content: space-between;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						justify-content: space-around;
					}

					.box-btn-item {
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;
						margin: 0 auto;
						cursor: pointer;

						/* 笔记本屏幕适配 */
						@media (min-width: 1024px) and (max-width: 1440px) {
							margin: 0 10px;
						}

						.el-image {
							width: 32px;
							height: 32px;

							/* 笔记本屏幕适配 */
							@media (min-width: 1024px) and (max-width: 1440px) {
								width: 28px;
								height: 28px;
							}
						}

						div {
							text-align: center;
							color: #333333;
							margin-top: 10px;
							font-size: 16px;

							/* 笔记本屏幕适配 */
							@media (min-width: 1024px) and (max-width: 1440px) {
								font-size: 14px;
								margin-top: 8px;
							}
						}
					}
				}

				.table {
					width: 100%;

					.table-item {
						width: 100%;
						display: flex;
						padding: 15px 20px;
						border-bottom: 1px solid #EEEEEE;
						font-size: 14px;
						color: #666666;

						/* 笔记本屏幕适配 */
						@media (min-width: 1024px) and (max-width: 1440px) {
							padding: 12px 15px;
							font-size: 13px;
						}

						.table-title {
							width: 25%;

							/* 笔记本屏幕适配 */
							@media (min-width: 1024px) and (max-width: 1440px) {
								width: 25%;
								word-break: break-all;
							}
						}
					}

					.table-item:last-child {
						border: none;
					}

					.table-header {
						background-color: #F7F7F7;
						color: #333333;

						/* 笔记本屏幕适配 */
						@media (min-width: 1024px) and (max-width: 1440px) {
							font-weight: bold;
						}
					}
				}

				.item {
					display: flex;
					justify-content: space-between;
					font-size: 14px;
					margin-bottom: 15px;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						font-size: 13px;
						margin-bottom: 12px;
					}

					.item-title {
						color: #666666;
					}

					.item-value {
						color: #333333;
					}
				}

				.more {
					padding-top: 20px;
					border-top: 1px solid #EEEEEE;
					font-size: 14px;
					color: #999999;
					text-align: center;
					cursor: pointer;

					/* 笔记本屏幕适配 */
					@media (min-width: 1024px) and (max-width: 1440px) {
						padding-top: 18px;
						font-size: 13px;
					}
				}
			}
		}
		
		.form {
			margin-top: -20px;
			
			/* 笔记本屏幕适配 */
			@media (min-width: 1024px) and (max-width: 1440px) {
				margin-top: -15px;
			}
			
			.invoice-btn {
				width: 130px;
				border-radius: 50px;
				line-height: 30px;
				font-size: 14px;
				color: #999999;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					width: 120px;
					line-height: 28px;
					font-size: 13px;
				}
			}
			
			.save {
				background-color: #2280FD;
				color: #fff;
			}
			
			.el-form-item {
				margin-bottom: 20px;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					margin-bottom: 18px;
				}
			}
			
			.el-input, .el-textarea {
				width: 100%;
			}
			
			.form-tip {
				font-size: 12px;
				color: #ff4d4f;
				margin-top: 5px;

				/* 笔记本屏幕适配 */
				@media (min-width: 1024px) and (max-width: 1440px) {
					font-size: 11px;
					margin-top: 4px;
				}
			}
			
			// 禁用状态的样式
			.el-radio.is-disabled {
				color: #c0c4cc;
				cursor: not-allowed;
			}

			/* 笔记本屏幕适配 - 表单标签 */
			::v-deep .el-form-item__label {
				@media (min-width: 1024px) and (max-width: 1440px) {
					font-size: 13px;
				}
			}

			/* 笔记本屏幕适配 - 表单内容 */
			::v-deep .el-input__inner,
			::v-deep .el-textarea__inner {
				@media (min-width: 1024px) and (max-width: 1440px) {
					font-size: 13px;
				}
			}
		}

		/* 笔记本屏幕适配 - 弹窗 */
		::v-deep .el-dialog {
			@media (min-width: 1024px) and (max-width: 1440px) {
				width: 50% !important;
			}
		}

		/* 笔记本屏幕适配 - 弹窗标题 */
		::v-deep .el-dialog__title {
			@media (min-width: 1024px) and (max-width: 1440px) {
				font-size: 16px;
			}
		}
	}
</style>